exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".asset-preview:hover .card-body .asset-info.stay[data-v-5ea365ec]{opacity:1}.asset-preview .title[data-v-5ea365ec]{overflow-wrap:anywhere}", ""]);

// exports
